import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import Select from "react-select";
import { Link } from "react-router-dom";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { changeKeysResponsibilitiesStatus, fetchCategories, fetchDepartments, fetchDesignations, fetchKeysResponsibilities, fetchPositions, fetchRoles, saveKeysResponsibilities } from "store/actions";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const KeysResponsibilities = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    keys_responsibilities,
    designations,
    departments,
    positions,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    keys_responsibilities: state.RecruitmentKeysRespReducer?.keys_responsibilities ?? [],
    designations: state.DesignationMaster?.designations ?? [],
    departments: state.DepartmentMaster?.departments ?? [],
    positions: state.JobSetupPositionSkillReducer?.positions ?? [],

    loading: state.RecruitmentKeysRespReducer?.loading || state.DesignationMaster?.loading || state.DepartmentMaster?.loading || state.JobSetupPositionSkillReducer?.loading,
    error: state.RecruitmentKeysRespReducer?.error || state.DesignationMaster?.error || state.DepartmentMaster?.error || state.JobSetupPositionSkillReducer?.error,
    success: state.RecruitmentKeysRespReducer?.success,
  }));

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchKeysResponsibilities(unitId));
    dispatch(fetchDesignations(unitId))
    dispatch(fetchDepartments(unitId))
    dispatch(fetchPositions(unitId))
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(fetchKeysResponsibilities(authDetails?.unit_id));
      setIsEdit(false);
      setEditId(null);
      formik.resetForm()
    }
  }, [authDetails, success, dispatch]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      department: "",
      role: "",
      position: "",
      responsibilities: "",
    },
    validationSchema: Yup.object({
      department: Yup.object().required("Please select a department"),
      role: Yup.object().required("Please select a role"),
      position: Yup.object().required("Please select a position"),
      responsibilities: Yup.string().required("Please enter responsibilities"),
    }),
    onSubmit: (values, { resetForm }) => {
      // if (isEdit) {
      //   setData((prevData) =>
      //     prevData.map((item) =>
      //       item.id === editId ? { ...item, ...values } : item
      //     )
      //   );
      //   setIsEdit(false);
      //   setEditId(null);
      // } else {
      //   const newRow = {
      //     id: data.length + 1,
      //     ...values,
      //     isActive: true,
      //   };
      //   setData((prev) => [...prev, newRow]);
      // }
      // resetForm();
      const payload = new FormData();
      payload.append("mkr_id", isEdit ? editId : 0);
      payload.append("dept_id", values.department?.value);
      payload.append("role_id", values.role?.value);
      payload.append("pos_id", values.position?.value);
      payload.append("keys_response", values.responsibilities);
      payload.append("unit_id", authDetails?.unit_id);
      payload.append("create_by", authDetails?.user_id);
      dispatch(saveKeysResponsibilities(payload))
    },
  });

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditId(row.mkr_id);
    const departmentObj = departments.find(
      emp => emp.departmentId === row.dept_id
    );
    const roleObj = designations.find(
      r => r.desig_id === row.role_id
    );
    const positionObj = positions.find(
      p => p.mpos_id === row.mpos_id
    );
    formik.setValues({
      department: {
        value: departmentObj?.departmentId,
        label: departmentObj?.departmentname
      },
      role: {
        value: roleObj?.desig_id,
        label: roleObj?.designation
      },
      position: {
        value: positionObj?.mpos_id,
        label: positionObj?.pos
      },
      responsibilities: row.keys_response,
    });
  };

  // const columns = [
  //   {
  //     Header: "Action",
  //     Cell: (cellProps) => {
  //       const { b_active, mkr_id } = cellProps.row.original;
  //       const isActive = b_active === 1; // Status 1 = Active
  //       return (
  //         <div className="d-flex gap-3">
  //           <Link
  //             to="#"
  //             className="text-success"
  //             onClick={() => handleEdit(cellProps.row.original)}
  //           >
  //             <i className="bx bxs-edit font-size-18" id="edittooltip" />
  //             <UncontrolledTooltip placement="top" target="edittooltip">
  //               Edit
  //             </UncontrolledTooltip>
  //           </Link>
  //           <Link
  //             to="#"
  //             style={{ color: isActive ? "green" : "red" }}
  //             onClick={() => handleToggleStatus(mkr_id, isActive)}
  //           >
  //             <i
  //               className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
  //               id={`status-tooltip-${cellProps.row.id}`}
  //             />
  //             <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
  //               {isActive ? "Mark Inactive" : "Mark Active"}
  //             </UncontrolledTooltip>
  //           </Link>
  //         </div>
  //       );
  //     },
  //   },
  //   { Header: "S.No", Cell: ({ row }) => keys_responsibilities.length - row.index, className: "serial-no", applyHeaderClass: true, },
  //   { Header: "Department", accessor: "department" },
  //   { Header: "Role", accessor: "role" },
  //   { Header: "Keys & Responsibilities", accessor: "keys_response" },
  // ];

  const columns = useMemo(() => {
    const actionColumn = {
      Header: "Action",
      Cell: (cellProps) => {
        const { b_active, mkr_id } = cellProps.row.original;
        const isActive = b_active === 1;

        return (
          <div className="d-flex gap-3">
            {canEdit && (
              <Link
                to="#"
                className="text-success"
                onClick={() => handleEdit(cellProps.row.original)}
              >
                <i className="bx bxs-edit font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
            )}

            {canDelete && (
              <Link
                to="#"
                style={{ color: isActive ? "green" : "red" }}
                onClick={() => handleToggleStatus(mkr_id, isActive)}
              >
                <i
                  className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
                  id={`status-tooltip-${cellProps.row.id}`}
                />
                <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
                  {isActive ? "Mark Inactive" : "Mark Active"}
                </UncontrolledTooltip>
              </Link>
            )}
          </div>
        );
      },
    };

    return [
      ...(canEdit || canDelete ? [actionColumn] : []), // 👈 Add only if permission available
      {
        Header: "S.No",
        Cell: ({ row }) => keys_responsibilities.length - row.index,
        className: "serial-no",
        applyHeaderClass: true,
      },
      { Header: "Department", accessor: "department" },
      { Header: "Role", accessor: "role" },
      { Header: "Position", accessor: "position" },
      { Header: "Keys & Responsibilities", accessor: "keys_response" },
    ];
  }, [canEdit, canDelete, keys_responsibilities]);


  const handleToggleStatus = (id, isActive) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${isActive ? 'deactivate' : 'activate'} this.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("mkr_id", id);
        formData.append("create_by", authDetails?.user_id);
        dispatch(changeKeysResponsibilitiesStatus(formData));
      }
    });
  };

  // select custome style
  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 40,
      minHeight: 40,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Setup" breadcrumbItem="Keys & Responsibilities" />
        {(canCreate || canEdit) && (
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="mb-3 ">
                <Col md="3">
                  <FormGroup>
                    <Label>Department <span className="text-danger">*</span></Label>
                    <Select
                      styles={SelectcustomStyles}
                      id="department"
                      name="department"
                      options={departments.map(emp => ({ value: emp.departmentId, label: emp.departmentname }))}
                      value={formik.values.department}
                      onChange={selectedOption => formik.setFieldValue("department", selectedOption)}
                      onBlur={() => formik.setFieldTouched("department", true)}  // ✅ Ensure onBlur is handled
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                      isDisabled={isEdit}
                    />
                    {formik.touched.department && formik.errors.department ? (
                      <div className="text-danger">{formik.errors.department}</div>
                    ) : null}

                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label>Role <span className="text-danger">*</span></Label>
                    <Select
                      styles={SelectcustomStyles}
                      id="role"
                      name="role"
                      options={designations.map(emp => ({ value: emp.desig_id, label: emp.designation }))}
                      value={formik.values.role}
                      onChange={selectedOption => formik.setFieldValue("role", selectedOption)}
                      onBlur={() => formik.setFieldTouched("role", true)}  // ✅ Ensure onBlur is handled
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                      isDisabled={isEdit}
                    />
                    {formik.touched.role && formik.errors.role ? (
                      <div className="text-danger">{formik.errors.role}</div>
                    ) : null}

                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label>Position <span className="text-danger">*</span></Label>
                    <Select
                      styles={SelectcustomStyles}
                      id="position"
                      name="position"
                      options={positions.map(p => ({ value: p.mpos_id, label: p.pos }))}
                      value={formik.values.position}
                      onChange={selectedOption => formik.setFieldValue("position", selectedOption)}
                      onBlur={() => formik.setFieldTouched("position", true)}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                      isDisabled={isEdit}
                    />
                    {formik.touched.position && formik.errors.position ? (
                      <div className="text-danger">{formik.errors.position}</div>
                    ) : null}
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label>Keys & Responsibilities <span className="text-danger">*</span></Label>
                    <Input
                      type="textarea"
                      id="responsibilities"
                      name="responsibilities"
                      value={formik.values.responsibilities}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      style={{ maxHeight: "42px", minHeight: "42px" }} // Ensures it stays at 33.1px
                    />

                    {formik.touched.responsibilities && formik.errors.responsibilities ? (
                      <div className="text-danger">{formik.errors.responsibilities}</div>
                    ) : null}

                  </FormGroup>
                </Col>
                <Col className="d-flex justify-content-end align-items-center">
                  <Button type="submit" className="btn button-save me-2 mt-2">
                    <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                  </Button>
                  <Button type="button" color="secondary"
                    onClick={() => {
                      formik.handleReset(); // reset the form
                      setIsEdit(false);     // set isEdit to false
                    }} className="btn button-cancel mt-2"> <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
        )}
        <Card>
          <CardBody>
            <TableContainer columns={columns} data={keys_responsibilities.length > 0 ? keys_responsibilities : []} isGlobalFilter={true} customPageSize={10} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default KeysResponsibilities;